<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<div class="image">
  <img src="../../../assets/img/lorry.svg" />
</div>

<form class="admin-forms" [formGroup]="notifyform">
  <div class="accordion-class">
    <h5>Corporate Notify Near by Drivers</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>WO ID</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              dropLocationSearchField
              formControlName="workorder_id"
              required
            >
              <mat-option
                *ngFor="let item of workorderArray"
                [value]="item._id"
                (click)="selectChangeHandler(item)"
              >
                {{ item.workorder_id }}
              </mat-option>
            </mat-select>
            <mat-error>Please select WO ID</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Max Trips</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm example-full-width">
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="max_trip"
              required
            />
            <mat-error>Please Enter valid Max Trip no </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Pickup</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm example-full-width">
            <input
              style="color: black"
              formControlName="from_city_name"
              matInput
              readonly
            />
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-label>Drop Location</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm">
            <input
              style="color: black; float: right"
              formControlName="to_city_name"
              matInput
              readonly
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label>Total Tons</label>
        </div>

        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm example-full-width">
            <input matInput formControlName="work_order_quantity" readonly />
            <mat-error>Please enter total tons </mat-error>
          </mat-form-field>
        </div>
      </div>
      <hr />
      <h5 class="c2">Trip Details</h5>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label> Trip Booking Date</label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker1></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker1"
              placeholder="DD-MM-YYYY"
              [min]="minDate"
              formControlName="trip_booking_date"
              (click)="picker1.open()"
              required
            />
            <mat-error>Please Enter Trip Booking Date </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <label>Truck Category</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              dropLocationSearchField
              formControlName="truck_category_name"
              required
            >
              <mat-option
                *ngFor="let item of truckCategory"
                [value]="item._id"
                (click)="selectChangeHandlerTruckcategory(item)"
              >
                {{ item.truck_category_name }}
              </mat-option>
            </mat-select>
            <mat-error>Please select truck category</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label>Load Details</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input matInput formControlName="material_type" readonly />
            <mat-error>Please Enter Valid Load Details</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label>Truck Weight</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input matInput formControlName="truck_weight" />
            <mat-error>Please Enter Truck Weight</mat-error>

            <!-- (focusout)="remainingQnty($event)" -->
          </mat-form-field>
        </div>
      </div>
      <br />
      <hr />
      <h5 class="c3">Notification Settings (From Pickup)</h5>
      <br />

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-radio-button
            [checked]="selectedOption === 'notificationRadius'"
            (change)="onSelectionChange('notificationRadius')"
          >
          </mat-radio-button>
          <label>Notification Radius</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="notification_radius"
              [readonly]="selectedOption !== 'notificationRadius'"
              (ngModelChange)="onNotificationRadiusChange($event)"
              required
            />
            <mat-error>Please enter notification radius</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label>KMS</label>
        </div>
        <div class="col-md-3">
          <mat-radio-button
            formControlName="all_transporters"
            [value]="'allTransporters'"
            (click)="selectLoadedQty('true')"
            (change)="onSelectionChange('allTransporters')"
          >
          </mat-radio-button>
          <label for="html">All Transporters</label>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-radio-button
            [checked]="selectedOption === 'truckHomeLocations'"
            (change)="onSelectionChange('truckHomeLocations')"
          >
          </mat-radio-button>
          <label>Truck Home Locations</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              formControlName="truck_home_location"
              (selectionChange)="onTruckHomeLocationChange($event)"
              [disabled]="selectedOption !== 'truckHomeLocations'"
              required
            >
              <mat-option *ngFor="let item of cityData" [value]="item">{{
                item
              }}</mat-option>
            </mat-select>
            <mat-error>Please select truck home locations</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label>Timer</label>
        </div>
        <div class="col-md-3 d-flex">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="timer"
              required
            />
            <mat-error>Please enter timer</mat-error>
          </mat-form-field>
          <p class="Mins">Mins</p>
        </div>
      </div>
      <div class="row">
        <div class="ex0 buttons">
          <button
            type="submit"
            class="button buttonBlue"
            [class.spinner]="loading"
            [ngClass]="{ 'button-disabled': loading || !notifyform.valid }"
            [disabled]="loading || !notifyform.valid"
            (click)="notify($event)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
